export default __webpack_public_path__ + "static/media/intervw_plan.4d702236.svg";